"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[839],{

/***/ 47518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5616);



var Container = function(param) {
    var children = param.children, sx = param.sx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            m: 1,
            position: "relative",
            width: {
                xs: "100%",
                lg: "50%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            }
        }, sx),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 98117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K3": function() { return /* binding */ saveLicense; },
/* harmony export */   "Mu": function() { return /* binding */ verifyOtp; },
/* harmony export */   "_u": function() { return /* binding */ getPayors; },
/* harmony export */   "aQ": function() { return /* binding */ addIntake; },
/* harmony export */   "eF": function() { return /* binding */ getAllergies; },
/* harmony export */   "g$": function() { return /* binding */ refreshToken; },
/* harmony export */   "ls": function() { return /* binding */ getIntake; },
/* harmony export */   "my": function() { return /* binding */ addWeightLoss; },
/* harmony export */   "xj": function() { return /* binding */ updateIntake; },
/* harmony export */   "xs": function() { return /* binding */ getOtp; },
/* harmony export */   "yl": function() { return /* binding */ addAllergies; }
/* harmony export */ });
/* unused harmony exports useIntake, saveInsurance, getLicense, saveAllergies */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42309);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64487);







var useIntake = function(emailorPhone) {
    var ref = useSWR(emailorPhone ? "".concat("https://api-auth.thrivelab.com/api", "/intake/").concat(emailorPhone) : null, axiosFetcher), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        data: data || {},
        isLoading: !error && !data,
        error: error,
        mutate: mutate
    };
};
var addWeightLoss = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params, token) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    result = undefined;
                    if (!(token && token !== "")) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 4;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/intake/weightloss"), params, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            accept: "application/json"
                        }
                    });
                case 4:
                    result = _ctx.sent;
                    _ctx.next = 9;
                    break;
                case 7:
                    _ctx.next = 9;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/intake/weightloss"), params);
                case 9:
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data || {}), {
                        status: status,
                        isLoading: false,
                        timeout: status === 401,
                        isError: status !== 201
                    }));
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function addWeightLoss(params, token) {
        return _ref.apply(this, arguments);
    };
}();
var addAllergies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params, token) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/intake/allergy"), params, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            accept: "application/json"
                        }
                    });
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data || {}), {
                        status: status,
                        isLoading: false,
                        isError: status !== 201
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function addAllergies(params, token) {
        return _ref.apply(this, arguments);
    };
}();
var addIntake = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params, token) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/intake"), params, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            accept: "application/json"
                        }
                    });
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data || {}), {
                        status: status,
                        isLoading: false,
                        isError: status !== 201
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function addIntake(params, token) {
        return _ref.apply(this, arguments);
    };
}();
var getIntake = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(emailorPhone, token) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (emailorPhone) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        data: {},
                        status: 200,
                        isLoading: false,
                        isError: false
                    });
                case 2:
                    _ctx.next = 4;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat("https://api-auth.thrivelab.com/api", "/intake/").concat(emailorPhone), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            accept: "application/json"
                        }
                    });
                case 4:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: status === 401
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getIntake(emailorPhone, token) {
        return _ref.apply(this, arguments);
    };
}();
var getOtp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/patient/2fa"), params);
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getOtp(params) {
        return _ref.apply(this, arguments);
    };
}();
var refreshToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/patient/refresh"), {
                        token: token
                    });
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function refreshToken(token) {
        return _ref.apply(this, arguments);
    };
}();
var verifyOtp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/patient/2fa/verify"), params);
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function verifyOtp(params) {
        return _ref.apply(this, arguments);
    };
}();
var getPayors = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat("https://api-auth.thrivelab.com/api", "/insurance/list/payors"), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            accept: "application/json"
                        }
                    });
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPayors(token) {
        return _ref.apply(this, arguments);
    };
}();
var saveInsurance = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params, token) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/intake/insurance"), params, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            accept: "application/json"
                        }
                    });
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function saveInsurance(params, token) {
        return _ref.apply(this, arguments);
    };
}();
var saveLicense = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params, token) {
        var ref, ref1, ref2, formData, ref3, result, data, status, ref4, ref5, ref6;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    ;
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .addBreadcrumb */ .n_({
                        category: "file-upload",
                        message: "License upload started",
                        level: "info",
                        data: {
                            email: params.email,
                            type: (ref2 = params === null || params === void 0 ? void 0 : params.type) !== null && ref2 !== void 0 ? ref2 : "",
                            extension: params === null || params === void 0 ? void 0 : params.extension,
                            fileSize: (ref = params.file) === null || ref === void 0 ? void 0 : ref.size,
                            fileName: (ref1 = params.file) === null || ref1 === void 0 ? void 0 : ref1.name
                        }
                    });
                    formData = new FormData();
                    formData.append("file", params.file);
                    formData.append("email", params.email);
                    ;
                    formData.append("type", (ref3 = params === null || params === void 0 ? void 0 : params.type) !== null && ref3 !== void 0 ? ref3 : "");
                    formData.append("extension", params === null || params === void 0 ? void 0 : params.extension);
                    formData.append("number", params === null || params === void 0 ? void 0 : params.number);
                    _ctx.next = 13;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/license/v2"), formData, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "multipart/form-data",
                            accept: "application/json"
                        }
                    });
                case 13:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .addBreadcrumb */ .n_({
                        category: "file-upload",
                        message: "License upload completed successfully",
                        level: "info",
                        data: {
                            status: status,
                            email: params.email
                        }
                    });
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: status !== 201
                    });
                case 19:
                    _ctx.prev = 19;
                    _ctx.t0 = _ctx["catch"](0);
                    ;
                    ;
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .captureException */ .Tb(_ctx.t0, {
                        tags: {
                            function: "saveLicense",
                            uploadType: "license"
                        },
                        extra: {
                            email: params.email,
                            type: (ref6 = params === null || params === void 0 ? void 0 : params.type) !== null && ref6 !== void 0 ? ref6 : "",
                            extension: params === null || params === void 0 ? void 0 : params.extension,
                            fileSize: (ref4 = params.file) === null || ref4 === void 0 ? void 0 : ref4.size,
                            fileName: (ref5 = params.file) === null || ref5 === void 0 ? void 0 : ref5.name
                        }
                    });
                    return _ctx.abrupt("return", {
                        data: _ctx.t0,
                        status: 500,
                        isLoading: false,
                        isError: true
                    });
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                19
            ]
        ]);
    }));
    return function saveLicense(params, token) {
        return _ref.apply(this, arguments);
    };
}();
var getLicense = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(filename, token) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat("https://api-auth.thrivelab.com/api", "/intake/").concat(filename, "/license"), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            accept: "application/json"
                        }
                    });
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLicense(filename, token) {
        return _ref.apply(this, arguments);
    };
}();
var updateIntake = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id, params, token) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].put */ .Z.put("".concat("https://api-auth.thrivelab.com/api", "/intake/").concat(id), params, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            accept: "application/json"
                        }
                    });
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        timeout: status === 401,
                        isLoading: false,
                        isError: status !== 200
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateIntake(id, params, token) {
        return _ref.apply(this, arguments);
    };
}();
var getAllergies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(name) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(name === "" || name === undefined)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        data: [],
                        status: 200,
                        isLoading: false,
                        isError: false
                    });
                case 2:
                    _ctx.next = 4;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat("https://api-auth.thrivelab.com/api", "/allergies/").concat(name));
                case 4:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getAllergies(name) {
        return _ref.apply(this, arguments);
    };
}();
var saveAllergies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(name) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/allergies"), name);
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: status !== 201
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function saveAllergies(name) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 78933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TV": function() { return /* binding */ useWeightLossStore; },
/* harmony export */   "c$": function() { return /* binding */ useIntakeStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(782);




var allergyInfo = {
    email: "",
    phone: "",
    Allergies: {}
};
var intakeInfo = {
    email: "",
    otp: "",
    id: "",
    birthControl: "",
    lastBoneDensity: "",
    lastMammogram: "",
    lastMenstrual: "",
    lastPelvicUltrasound: "",
    noAbortions: "",
    noChildren: "",
    noMiscarriages: "",
    noPregnancies: "",
    abnormalPap: "",
    gender: "",
    driverLicense: undefined,
    maritalStatus: "",
    previouslyTriedHormoneTherapy: "",
    stressAtHome: "",
    stressLevel: "",
    lastDigitalRectal: "",
    lastPsaProstate: "",
    lastColonoscopySigmoidoscopy: "",
    lastCardiacStress: "",
    desireChildren: "",
    insurerName: "",
    policyHolderName: "",
    policyNumber: "",
    groupNumber: "",
    cardiovascular: [],
    gastrointestinal: [],
    general: [],
    genitourinary: [],
    liverDisease: [],
    musculoskeletal: [],
    neurological: [],
    respiratory: [],
    surgicalProcedures: [],
    currentMeds: [],
    endocrine: [],
    autoImmune: [],
    psychiatric: [],
    lastPapSmear: "",
    type: "",
    when: "",
    status: "",
    primaryInsurance: undefined,
    secondaryInsurance: undefined,
    hasInsurance: false,
    submitting: false,
    Do_you_have_insurance: ""
};
var weightLossInfo = {
    desired_weight: "",
    diet_notes: "",
    exercise: {
        exercise_1: {
            type: "",
            hours_per_week: ""
        },
        exercise_2: {
            type: "",
            hours_per_week: ""
        },
        exercise_3: {
            type: "",
            hours_per_week: ""
        },
        exercise_4: {
            type: "",
            hours_per_week: ""
        },
        exercise_5: {
            type: "",
            hours_per_week: ""
        }
    },
    habits: {},
    weight_history: {
        current: {
            weight: "",
            age: "",
            notes: ""
        },
        highest: {
            weight: "",
            age: "",
            notes: ""
        },
        lowest: {
            weight: "",
            age: "",
            notes: ""
        }
    },
    motivation_for_losing_weight: "",
    eating_habits: {
        breakfast: {
            food_type: "",
            time: ""
        },
        dessert: {
            food_type: "",
            time: ""
        },
        dinner: {
            food_type: "",
            time: ""
        },
        lunch: {
            food_type: "",
            time: ""
        },
        snack: {
            food_type: "",
            time: ""
        },
        eat_to_relieve_stress_or_deal_with_emo: "",
        Do_you_have_a_history_of_disordered_eating: "",
        glasses_of_water_a_day: "",
        willing_to_make_diet_modifications: "",
        How_many_times_fast_food: ""
    }
};
var useWeightLossStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, weightLossInfo), {
        setData: function(data) {
            return set(function(state) {
                if (!data) return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state, weightLossInfo);
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state, data);
            });
        }
    });
}, {
    name: "intake-weightloss",
    storage: (0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .createJSONStorage */ .FL)(function() {
        return sessionStorage;
    })
})));
var useIntakeStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, intakeInfo), {
        setData: function(data) {
            return set(function(state) {
                if (!data) {
                    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state, intakeInfo);
                }
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state, data);
            });
        }
    });
}, {
    name: "intake",
    storage: (0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .createJSONStorage */ .FL)(function() {
        return sessionStorage;
    })
})));
var useAllergyStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, allergyInfo), {
        setData: function(data) {
            return set(function(state) {
                if (!data) return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                    email: "",
                    phone: "",
                    Allergies: {}
                });
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state, data);
            });
        }
    });
}, {
    name: "intake-allergy",
    storage: (0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .createJSONStorage */ .FL)(function() {
        return sessionStorage;
    })
})));
/* harmony default export */ __webpack_exports__["ZP"] = (useAllergyStore);


/***/ })

}]);